import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { formatDateTime, priorityClass, priorityLabel } from '../../utils/labels';
export function AdminAnnouncements() {
  const {
    announcements
  } = useApp();
  return <div className="space-y-5" data-id="element-552" data-mp="18zyw0t6ytfbd">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-553" data-mp="13z1fel1lstbz">
        <div data-id="element-554" data-mp="140vydttbebdf">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-555" data-mp="1iw29gv79p0dm">Obvestila</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-556" data-mp="1ixd8khprpjye">Uradna komunikacija vodstva s člani.</p>
        </div>
        <Link to="/admin/obvestila/novo" data-id="element-557" data-mp="1dz230j6i9vlz">
          <Button variant="accent" data-id="element-558" data-mp="2uafsnmr2srnb">
            <PlusIcon className="h-4 w-4" data-id="element-559" data-mp="2u9ny8f97szym" />
            Novo obvestilo
          </Button>
        </Link>
      </div>

      <Card className="overflow-hidden" data-id="element-560" data-mp="2pe8itivk6w03">
        <div className="overflow-x-auto viva-scroll" data-id="element-561" data-mp="5dde07y8t0by">
          <table className="w-full min-w-[880px] text-left text-sm" data-id="element-562" data-mp="5ey49ldixx40">
            <thead className="border-b border-line bg-canvas text-[12px] uppercase tracking-wide text-ink-muted" data-id="element-563" data-mp="aan7pzsnzy5l">
              <tr data-id="element-564" data-mp="fbt2s49srxia">
                <th className="px-5 py-3 font-medium" data-id="element-565" data-mp="f96x6a6gvs2p">Obvestilo</th>
                <th className="px-4 py-3 font-medium" data-id="element-566" data-mp="jc37ldlushvk">Prioriteta</th>
                <th className="px-4 py-3 font-medium" data-id="element-567" data-mp="3isjd2vcewwps">Prejemniki</th>
                <th className="px-4 py-3 font-medium" data-id="element-568" data-mp="3nqumx62pj780">Branost</th>
                <th className="px-4 py-3 font-medium" data-id="element-569" data-mp="3nrcvn26k3dwt">Objavljeno</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-570" data-mp="3rr55rjblls4a">
              {announcements.map(a => {
              const delez = Math.round(a.prebrali.length / Math.max(a.prejemniki.length, 1) * 100);
              return <tr key={a.id} className="transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-571" data-mp="342u8eq542akr">
                    <td className="px-5 py-3" data-id="element-572" data-mp="b8di9m0vptnj">
                      <Link to={`/admin/obvestila/${a.id}/branost`} className="font-medium text-ink hover:text-green-700" data-id="element-573" data-mp="b72g1qn30tyj">
                        {a.naslov}
                      </Link>
                      <span className="block text-[12px] text-ink-muted" data-id="element-574" data-mp="fzc5z6o75u0t">
                        {a.avtor}
                        {a.zahtevaPotrditev ? ' · zahteva potrditev' : ''}
                      </span>
                    </td>
                    <td className="px-4 py-3" data-id="element-575" data-mp="3jh412txmqu38">
                      <Badge className={priorityClass[a.prioriteta]} data-id="element-576" data-mp="1a7jveea75nf">{priorityLabel[a.prioriteta]}</Badge>
                    </td>
                    <td className="px-4 py-3 text-[13px] text-ink-muted" data-id="element-577" data-mp="3tdqkrfe7zf3o">
                      {a.obcinstvoLabel}
                      <span className="block text-[12px]" data-id="element-578" data-mp="1co1liqccqajm">{a.prejemniki.length} oseb</span>
                    </td>
                    <td className="px-4 py-3" data-id="element-579" data-mp="18n7v9qbfsjnk">
                      <div className="flex items-center gap-2" data-id="element-580" data-mp="1g7jv5qdcsis0">
                        <div className="h-1.5 w-24 overflow-hidden rounded-full bg-canvas" data-id="element-581" data-mp="1g9d63hv01p5t">
                          <div className="h-full rounded-full bg-purple-500" style={{
                        width: `${delez}%`
                      }} data-id="element-582" data-mp="1l7ohhx0y07q5" />
                        </div>
                        <span className="text-[13px] font-medium text-ink" data-id="element-583" data-mp="1b7xipj5cn6k9">{delez} %</span>
                      </div>
                      <span className="text-[12px] text-ink-muted" data-id="element-584" data-mp="1yxi5kd4minyt">
                        {a.prebrali.length} od {a.prejemniki.length}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-[13px] text-ink-muted" data-id="element-585" data-mp="1p8i5eqedxmj1">{formatDateTime(a.objavljeno)}</td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}